<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getList">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/project/info/${projectId}`">
      </f7-nav-left>
      <f7-nav-title>{{ this.$f7route.query.name }}</f7-nav-title>
      <f7-nav-right v-if="perms.projectCheckApply">
        <f7-link :href="`/acceptance/add/${projectId}`">申请</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div
      class="has-content"
      style="text-align: center;"
      v-if="acceptanceList.length === 0">
      暂无数据
    </div>
    <div v-else>
      <div
        class="item-accept-content"
        v-for="item in acceptanceList"
        :key="item.id">
        <f7-link :href="`/acceptance/info/${item.id}?projectId=${
          projectId}&name=${$f7route.query.name || ''}`">
          <div class="accept-title">
            <div class="title-icon"><f7-icon icon="cicon-yanshourenwu"></f7-icon></div>
            <div class="accept-title-text">{{item.title}}</div>
          </div>
          <div class="accept-date">
            <div style="flex: auto;">
              <div class="accept-date">
                <div>
                  提交日期： {{ item.submitTime | formatDateValue }}
                </div>
              </div>
              <div class="accept-date">
                <div>
                  通过日期： {{ item.acceptanceFinishedTime | formatDateValue }}
                </div>
              </div>
            </div>
            <div class="accept-title-finished" v-if="item.finished === '1'">完工验收</div>
            <div class="accept-title-building" v-else>进度验工</div>
          </div>
          <div>
            <p>{{ item.remark }}</p>
          </div>
        </f7-link>
        <div @click="browserPhoto(item.attachmentList)" style="padding: 0rem 0.5rem;">
          <f7-swiper
            :params="{speed:500, slidesPerView: 4, spaceBetween: 10,
              observer: true, observeParents: true}">
            <f7-swiper-slide
              v-for="attach in item.attachmentList"
              :key="attach">
              <div style="max-height: 6rem;">
                <img :src="imageUrl+'?attachmentId='+attach" style="width: 100%; height: 100%;"/>
              </div>
            </f7-swiper-slide>
          </f7-swiper>
        </div>
        <div class="accept-status">
          <div style="position: relative;">
            <div
              class="accept-status-content-mask"
              v-if="!item.acceptanceApproveVoMap.security.approvePerm ||
              (item.acceptanceApproveVoMap.security.approvePerm &&
              item.acceptanceApproveVoMap.security.result ==='agree')">
            </div>
            <div
              class="accept-status-security"
              @click="showApprove('安全验收', 'security', '安全考核', item)">
              <div class="accept-status-security-label">安全</div>
              <div class="accept-status-security-text">
                {{ item.acceptanceApproveVoMap.security.resultDesc || '未验收' }}
              </div>
            </div>
          </div>
          <div style="position: relative;">
            <div
              class="accept-status-content-mask"
              v-if="!item.acceptanceApproveVoMap.quality.approvePerm ||
              (item.acceptanceApproveVoMap.quality.approvePerm &&
              item.acceptanceApproveVoMap.quality.result ==='agree')">
            </div>
            <div
              class="accept-status-quality"
              @click="showApprove('质量验收', 'quality', '质量综合', item)">
              <div class="accept-status-quality-label">质量</div>
              <div class="accept-status-quality-text">
                {{ item.acceptanceApproveVoMap.quality.resultDesc || '未验收' }}
              </div>
            </div>
          </div>
          <div style="position: relative;">
            <div
              class="accept-status-content-mask"
              v-if="!item.acceptanceApproveVoMap.composite.approvePerm ||
              (item.acceptanceApproveVoMap.composite.approvePerm &&
              item.acceptanceApproveVoMap.composite.result ==='agree')">
            </div>
            <div
              class="accept-status-composite"
              @click="showApprove('综合验收', 'composite', '文明施工', item)">
              <div class="accept-status-composite-label">综合</div>
              <div class="accept-status-composite-text">
                {{ item.acceptanceApproveVoMap.composite.resultDesc || '未验收' }}
              </div>
            </div>
          </div>
          <div style="position: relative;">
            <div
              class="accept-status-content-mask"
              v-if="!item.acceptanceApproveVoMap.quantity.approvePerm ||
              (item.acceptanceApproveVoMap.quantity.approvePerm &&
              item.acceptanceApproveVoMap.quantity.result ==='agree')">
            </div>
            <div
              class="accept-status-quantity"
              @click="showApprove('数量核算', 'quantity', null, item)">
              <div class="accept-status-quantity-label">数量</div>
              <div class="accept-status-quantity-text">
                {{ item.acceptanceApproveVoMap.quantity.resultDesc || '未验收' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <f7-popup :opened="approveOpened" @popup:closed="approveOpened = false">
      <approve
        :project-id="projectId"
        :project="project"
        :title="title"
        :label="label"
        :project-acceptance-item="projectAcceptanceItem"
        :opened.sync="approveOpened">
      </approve>
    </f7-popup>
  </f7-page>
</template>
<script>
import { dateFormat } from '@/util/dateUtils';
import { imageView } from '@/api/common';
import { getAcceptanceList } from '@/api/acceptance';
import { Acceptance } from '@/model/reqObject';
import Approve from '@/pages/acceptance/approve';

export default {
  props: ['projectId'],
  components: {
    Approve,
  },
  data() {
    return {
      imageUrl: imageView,
      acceptanceList: [],
      acceptance: new Acceptance(),
      approveOpened: false,
      project: {},
      title: '',
      projectAcceptanceItem: '',
      label: '',
      perms: {},
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    approveOpened(newVal) {
      if (!newVal) {
        this.project = {};
        this.title = '';
        this.label = '';
        this.projectAcceptanceItem = '';
        this.getList();
      }
    },
  },
  filters: {
    formatDateValue: value => dateFormat(value, 'YYYY-MM-DD HH:mm'),
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    getList() {
      const params = { projectId: this.projectId };
      getAcceptanceList(params).then((result) => {
        if (result.code === 0) {
          this.acceptanceList = result.data || [];
          this.perms = result.perms || {};
        }
      });
    },
    showApprove(title, acceptanceItem, label, project) {
      this.project = project;
      this.title = title;
      this.label = label;
      this.projectAcceptanceItem = acceptanceItem;
      this.approveOpened = true;
    },
    browserPhoto(itemArr) {
      this.$f7.photoBrowser.create({
        photos: (itemArr || []).map(item => `${this.imageUrl}?attachmentId=${item}`),
        backLinkText: '返回',
        navbarOfText: '/',
        iconsColor: 'white',
        routableModals: false,
      }).open();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .item-accept-content {
    border-radius: 0.5rem;
    background-color: $white-color;
    margin: 0.5rem 0.5rem;
  }

  .title-icon {
    color: $theme-color;
    padding-right: 0.5rem;
  }

  .accept-title {
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    padding: 0.5rem 0.5rem;
  }

  .accept-title-text {
    flex: auto;
  }

  @mixin accept-title-status($bgColor, $color) {
    background-color: $bgColor;
    color: $color;
    border-radius: 0.3rem;
    padding: 0rem 0.8rem;
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 0.6rem;
  }

  .accept-title-finished {
    @include accept-title-status(#F8F8F8, #2F8811);
  }

  .accept-title-building {
    @include accept-title-status(#F8F8F8, #FFA000);
  }

  .accept-date {
    padding: 0rem 0.5rem;
    font-size: 0.7rem;
    color: #5A5A5A;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .accept-status {
    padding: 0.5rem 0.5rem;
    border-top: 0.05rem solid $border-color;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .accept-status-content-mask {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    border-radius: 0.3rem;
    filter:alpha(opacity = 70);
    opacity: 0.7;
    cursor: default;
  }

  @mixin accept-status-content($bgColor, $bdColor) {
    display: flex;
    flex-direction: column;
    border: 0.05rem solid $bdColor;
    border-radius: 0.3rem;
    font-size: 0.8rem;
    line-height: 1.2rem;
    width: 4rem;
    min-width: 4rem;
    cursor: pointer;
    &-label {
      text-align: center;
      background-color: $bgColor;
      border-radius: 0.3rem 0.3rem 0rem 0rem;
      color: $white-color;
      padding: 0rem 0.3rem;
    }
    &-text {
      text-align: center;
      color: $font-color;
      padding: 0.3rem 0.3rem 0rem 0.3rem;
    }
  }

  .accept-status-security {
    @include accept-status-content(#80C269, #CBD9AE);
  }

  .accept-status-quality {
    @include accept-status-content(#F39800, #FBDDAA);
  }

  .accept-status-composite {
    @include accept-status-content(#A6937C, #D4CEC8);
  }

  .accept-status-quantity {
    @include accept-status-content(#36B1C0, #BCE5EA);
  }

  .item-accept-space {
    background-color: $bg-color;
    height: 0.5rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/acceptance/list.vue